



















import { defineComponent } from '@vue/composition-api';

const name = 'dynamic-destination-switch-icon-question';
export default defineComponent({
  props: {
    // tos： https://bytedance.feishu.cn/wiki/Qd4SwiI0niB70GkEdfucpSTIn2g, 空间： tiktok_ads_fe
    imgSrc: {
      type: String,
      default: '',
    },
    introduce: {
      type: String,
      default: '',
    },
    ctaName: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 400,
    },
  },
  setup() {
    return {
      name,
    };
  },
});
